// @erp/module-auth/fe · the module's typed edge (DEV-GUIDE-002 §6.3 — a
// per-module hc client, never one giant hc<AppType>). `import type` is
// load-bearing: a VALUE import of '../api' would drag Hono, better-auth and D1
// into the browser bundle; type-only it is erased, AND it is the compile-time
// seam — if an invite route leaves the chained expression or its response shape
// drifts, AuthRoutes changes and this build fails typecheck.
//
// The plain-fetch helpers in ./index.tsx stay as they are: they call better-auth
// at /auth/*, whose routes are the LIBRARY'S and are not in AuthRoutes.
import type { AuthRoutes } from "../api/index.js";
import { createApiClient } from "@erp/api-client";

export const authApi = createApiClient<AuthRoutes>("/api/auth");
export type AuthApi = typeof authApi;
